// Where a social activity / notification should navigate — the SPECIFIC content it's
// about, not a generic show page. Audit 2026-08-11: review/reaction/comment/episode
// notifications all dead-ended on `/show/{id}`, which for an UNtracked show resolves to
// the About tab — so "X reviewed a show" or "you were mentioned in a review" dumped you
// on a marketing page with no way to reach the thing you tapped. This maps each type to
// its real destination. ShowPage17 reads no `?tab=` query, so a reaction/comment goes to
// the Aftershow route itself (FeatureGate explains if it's off).

export function activityDest(type, showId) {
  if (!showId) return null
  if (type === 'reacted' || type === 'comment') return `/aftershow/${showId}`
  return `/show/${showId}`
}

export function noticeDest(a) {
  const d = a?.data || {}
  if (d.route) return d.route
  if (d.room_id) return `/join/${d.room_id}`
  if (a?.show_id) return `/show/${a.show_id}`
  return null
}
